import { Anchor, Flex, Switch } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import moment from "moment";
import { useEffect } from "react";
import { useState } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import jobLogo from "../../assets/joblogo.jpg";
import location from "../../assets/location.svg";
import date from "../../assets/date.svg";
import ApplyModal from "../../components/ApplyModal";
import Button from "../../components/Button";
import routeNames from "../../routes/routeNames";
import { backendUrl } from "../../constants";

const JobCard = ({ data, setOpened, setViewJobId }) => {
  const navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem("userData"));
  const [applyModal, setApplyModal] = useState(false);
  const [applied, setApplied] = useState(false);

  useEffect(() => {
    data &&
      data.appliedCandidates?.map((obj) => {
        if (obj?.user === user?.id) {
          console.log("found", user.id, obj.user);
          setApplied(true);
          return 1;
        }
      });
  }, [data, user?.id]);

  const handleJobStatus = (key, status) => {
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify({
        jobId: key,
        status: status.target.checked ? "active" : "inactive",
        createdBy: user.id,
      }),
    };

    fetch(`${backendUrl}job/changeJobStatus`, options)
      .then((response) => response.json())
      .then((response) => {})
      .catch((err) => console.error(err));
  };

  const handleViewJob = () => {
    if (user?.id) {
      navigate(`/job/${data.key}`);
    } else {
      showNotification({
        title: "Oops!",
        message: "Please Login to view job details!",
        color: "red",
      });
      navigate(routeNames.general.login);
    }
  };
  const openApplyModal = () => {
    setApplyModal(true);
  };

  return (
    <div className="d-flex p-3 gap-2 shadow bg-white  mb-3 jobdet">
      <img
        src={data.logo || jobLogo}
        width="120px"
        height="120px"
        style={{ border: "1px solid rgb(0,0,0,0.2)", padding: "2px" }}
      />
      <div className="d-flex flex-column justify-content-around w-100">
        <Flex className="w-100" justify={"space-between"}>
          <h6 className="text-dark" onClick={handleViewJob}>
            {data?.title}
          </h6>
          {user && user?.id === data.companyId && (
            <Switch
              color={"red"}
              defaultChecked={data.state === "active" ? true : false}
              onChange={(v) => handleJobStatus(data.key, v)}
            />
          )}
        </Flex>

        <div className="d-flex gap-4 loc-s">
          <div className="d-flex">
            <img
              src={jobLogo}
              width="20px"
              height="20px"
              style={{ marginRight: "5px" }}
            />
            <h6 className="text-info">{data?.company || "Anonymous"}</h6>
          </div>
          <div className="d-flex">
            <img src={location} width="20px" height="20px" />
            <h6 className="text-info">{data?.location || "No Location"}</h6>
          </div>
        </div>
        <h6 className="text-info">
          {data.remote ? "Remote Position" : "On-site Position"}
        </h6>
        <Flex justify={"space-between"}>
          <Flex direction={"column"}>
            <h6
              style={{
                color: "rgb(0,0,0,0.5)",
                fontSize: "12px",
                marginBottom: "0px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img src={date} /> {new moment(data.date).format("DD MMM YYYY")}
            </h6>
          </Flex>
          {user && user?.id === data.companyId && (
            <Anchor
              onClick={() => {
                setViewJobId({ name: data?.title, id: data?.key });
                setOpened(true);
              }}
            >
              Applications
            </Anchor>
          )}
          {user?.role === "JobSeeker" && (
            <Button
              title={applied ? "Already Applied" : "Apply Now"}
              disable={applied}
              primary={true}
              style={{ fontSize: "12px", fontWeight: "600" }}
              onClick={openApplyModal}
            />
          )}
        </Flex>
        {user && (
          <ApplyModal
            opened={applyModal}
            setOpened={setApplyModal}
            jobId={data.key}
            setApplied={setApplied}
          />
        )}
      </div>
    </div>
  );
};
export default withTranslation()(JobCard);
